var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.wrapperClasses},[_c('div',{staticClass:"info_box_overlay"}),_vm._v(" "),_c('div',{staticClass:"info_box_body"},[_c('button',{staticClass:"info_box_close",attrs:{"type":"button"},on:{"click":_vm.close}}),_vm._v(" "),_c('div',{staticClass:"info_box_content"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }